import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-groups',
  templateUrl: './company-groups.component.html',
  styleUrls: ['./company-groups.component.css']
})
export class CompanyGroupsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
